import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment-timezone';
import { StateContext } from '../../../../../../StateProvider';
import { BackButton } from '../../../../../../Utilities/components/Buttons';
import {
  fetchAllFamilyMember,
  fetchAllUsers,
  createStaffBooking,
  // fetchServiceAvailability,
} from '../../../../../../Utilities/api';
import './ReceptionCreateBooking.css';

const ReceptionCreateBooking = function () {
  var navigate = useNavigate();
  var ctx = useContext(StateContext) || {};

  // TEMP: mock values for staff soft booking
  const MOCK_SERVICE_ID = 1; // must exist in Services table
  const MOCK_FAMILY_MEMBER_ID = null;

  /* -------------------------------
     SEARCH STATE
  -------------------------------- */
  var [searchTerm, setSearchTerm] = useState('');
  var [allRows, setAllRows] = useState([]);
  var [results, setResults] = useState([]);
  var [selectedOwner, setSelectedOwner] = useState(null);
  var [ownerPets, setOwnerPets] = useState([]);

  /* -------------------------------
     BOOKING STATE
  -------------------------------- */
  var [bookingType, setBookingType] = useState('');
  var [selectedPets, setSelectedPets] = useState([]);
  var [date, setDate] = useState('');
  var [timeSlot, setTimeSlot] = useState('');
  var [availableSlots, setAvailableSlots] = useState([]);

  // NOTE: basePrice is now staff-editable (manual set price)
  var [basePrice, setBasePrice] = useState('');

  // NOTE: promo supports % or $ amount (already supported; we keep it)
  var [discountType, setDiscountType] = useState('');
  var [discountValue, setDiscountValue] = useState('');
  var [finalPrice, setFinalPrice] = useState(0);

  var [notes, setNotes] = useState('');
  var [error, setError] = useState(null);

  /* -------------------------------
     LOAD USERS + PETS
  -------------------------------- */
  useEffect(function () {
    async function load() {
      try {
        var pets = await fetchAllFamilyMember();
        var users = await fetchAllUsers();

        var userMap = {};
        var petsByUser = {};
        var i;

        for (i = 0; i < users.length; i++) {
          userMap[users[i].uid] = users[i];
          petsByUser[users[i].uid] = [];
        }

        for (i = 0; i < pets.length; i++) {
          var p = pets[i];
          if (p.type !== 'Human' && petsByUser[p.userid]) {
            petsByUser[p.userid].push({
              petId: p.id,
              petName: p.name
            });
          }
        }

        var rows = [];

        for (i = 0; i < users.length; i++) {
          var u = users[i];
          rows.push({
            kind: 'owner',
            uid: u.uid,
            name: u.username || '',
            email: u.email || '',
            pets: petsByUser[u.uid] || []
          });
        }

        for (i = 0; i < pets.length; i++) {
          var pet = pets[i];
          if (pet.type === 'Human') continue;
          var owner = userMap[pet.userid];
          if (!owner) continue;

          rows.push({
            kind: 'pet',
            petId: pet.id,
            name: pet.name,
            ownerUid: owner.uid,
            ownerName: owner.username
          });
        }

        setAllRows(rows);
        setResults(rows);
      } catch (e) {
        console.error(e);
      }
    }

    load();
  }, []);

  /* -------------------------------
     SEARCH FILTER
  -------------------------------- */
  useEffect(function () {
    var s = (searchTerm || '').toLowerCase();
    var out = [];

    for (var i = 0; i < allRows.length; i++) {
      var r = allRows[i];
      var name = (r.name || '').toLowerCase();
      var email = (r.email || '').toLowerCase();
      var ownerName = (r.ownerName || '').toLowerCase();

      if (
        name.indexOf(s) > -1 ||
        email.indexOf(s) > -1 ||
        ownerName.indexOf(s) > -1
      ) {
        out.push(r);
      }
    }

    setResults(out);
  }, [searchTerm, allRows]);

  /* -------------------------------
     SELECT OWNER
  -------------------------------- */
  function handleSelect(row) {
    var ownerUid = row.kind === 'owner' ? row.uid : row.ownerUid;
    var ownerName = row.kind === 'owner' ? row.name : row.ownerName;

    var pets = [];
    for (var i = 0; i < allRows.length; i++) {
      var r = allRows[i];
      if (r.kind === 'owner' && r.uid === ownerUid) {
        pets = r.pets || [];
        break;
      }
    }

    setSelectedOwner({ uid: ownerUid, name: ownerName });
    setOwnerPets(pets);
    setSelectedPets([]);
  }

  /* -------------------------------
     BASE PRICING
     (kept as-is, but staff can now override basePrice input below)
  -------------------------------- */
  useEffect(function () {
    var prices = {
      Daycare: 38,
      Grooming: 100,
      Training: 90,
      Adventure: 75,
      Hotel: 68,
      Shuttle: 30
    };

    var p = prices[bookingType] || '';
    setBasePrice(p);
    setFinalPrice(p);
    setDiscountType('');
    setDiscountValue('');
  }, [bookingType]);

  /* -------------------------------
     DISCOUNT CALC
     (kept as-is, with basic clamping to avoid negative/invalid values)
  -------------------------------- */
  useEffect(function () {
  var price = Number(basePrice || 0);

  if (discountType === 'percent') {
    var pct = Number(discountValue || 0);
    if (pct < 0) pct = 0;
    if (pct > 100) pct = 100;
    price = price - price * (pct / 100);
  }

  if (discountType === 'amount') {
    var amt = Number(discountValue || 0);
    if (amt < 0) amt = 0;
    price = price - amt;
  }

  if (price < 0) price = 0;
  setFinalPrice(Number(price.toFixed(2)));
}, [basePrice, discountType, discountValue]);


  /* -------------------------------
     AVAILABILITY
     (REMOVED: no longer rendering slots; keep the rest of the component intact)
  -------------------------------- */
  // useEffect(function () {
  //   if (!bookingType || !date) return;
  //
  //   async function loadSlots() {
  //     try {
  //       var res = await fetchServiceAvailability({
  //         serviceType: bookingType,
  //         date: date
  //       });
  //       setAvailableSlots(res.slots || []);
  //     } catch (e) {
  //       setAvailableSlots([]);
  //     }
  //   }
  //
  //   loadSlots();
  // }, [bookingType, date]);

  /* -------------------------------
     SUBMIT
     (kept as-is; only removed slot requirement since slots are no longer rendered)
  -------------------------------- */
  function isValid() {
    return (
      selectedOwner &&
      bookingType &&
      date &&
      selectedPets.length > 0
    );
  }

  function normalizeDate(d) {
    return moment(d).startOf('day').toISOString();
  }

  async function handleProceed() {
    if (!isValid()) {
      setError('Please complete all required fields.');
      return;
    }

    try {
      const payload = {
        userId: selectedOwner.uid,

        // TEMP MOCK — replace when service selector is wired
        serviceId: MOCK_SERVICE_ID,

        bookingType,
        date,
        selectedPets: selectedPets.map(p => p.petId),
        originalPrice: Number(basePrice || 0),
        discountedPrice: finalPrice,
        promo: discountType
          ? { type: discountType, value: Number(discountValue || 0) }
          : null,
        notes
      };

      const res = await createStaffBooking(payload);
      navigate('/console/tasks/reception/reception-bookings');
    } catch (e) {
      setError('Failed to create booking.');
    }
  }

  /* -------------------------------
     RENDER
  -------------------------------- */
  return (
    <div className="rbc-wrap">
      <div className="rbc-topbar">
        <BackButton />
      </div>

      {!selectedOwner ? (
        <>
          <h2 className="rbc-title">Find Owner or Pet</h2>

          <input
            className="rbc-input"
            placeholder="Search name or email…"
            value={searchTerm}
            onChange={function (e) {
              setSearchTerm(e.target.value);
            }}
          />

          <div className="rbc-list">
            {results.map(function (row, i) {
              return (
                <div
                  key={i}
                  className="rbc-row"
                  onClick={function () {
                    handleSelect(row);
                  }}
                >
                  <div>
                    <strong>{row.name}</strong>
                    <div style={{ fontSize: 12, color: '#64748b' }}>
                      {row.kind === 'pet'
                        ? 'Pet · Owner: ' + row.ownerName
                        : row.email}
                    </div>
                    {row.kind === 'owner' && row.pets.length > 0 && (
                      <div style={{ fontSize: 12, color: '#475569' }}>
                        Pets: {row.pets
                          .map(function (p) {
                            return p.petName;
                          })
                          .join(', ')}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <>
          <h2 className="rbc-title">Booking for {selectedOwner.name}</h2>

          <div className="rbc-filter">
            <label>Pets</label>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {ownerPets.map(function (p) {
                var active = false;
                for (var i = 0; i < selectedPets.length; i++) {
                  if (selectedPets[i].petName === p.petName) active = true;
                }

                return (
                  <button
                    key={p.petId}
                    type="button"
                    className={'rbc-btn ' + (active ? 'rbc-btn--primary' : '')}
                    onClick={function () {
                      var next = [];
                      if (!active) {
                        next = selectedPets.concat([p]);
                      } else {
                        for (var j = 0; j < selectedPets.length; j++) {
                          if (selectedPets[j].petName !== p.petName) {
                            next.push(selectedPets[j]);
                          }
                        }
                      }
                      setSelectedPets(next);
                    }}
                  >
                    {p.petName}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="rbc-filter">
            <label>Service</label>
            <select
              className="rbc-select"
              value={bookingType}
              onChange={function (e) {
                setBookingType(e.target.value);
              }}
            >
              <option value="">Select</option>
              <option value="Daycare">Daycare</option>
              <option value="Grooming">Grooming</option>
              <option value="Training">Training</option>
              <option value="Adventure">Adventure</option>
              <option value="Hotel">Hotel</option>
              <option value="Shuttle">Shuttle</option>
            </select>
          </div>

          <div className="rbc-filter">
            <label>Date</label>
            <input
              type="date"
              className="rbc-input"
              value={date}
              onChange={function (e) {
                setDate(e.target.value);
              }}
            />
          </div>

          {/* Time Slot UI REMOVED as requested */}

          {/* Price: now editable (manual set price) */}
          <div className="rbc-filter">
            <label>Price</label>
            <input
              type="number"
              className="rbc-input"
              value={basePrice}
              onChange={function (e) {
                setBasePrice(e.target.value);
              }}
            />
            <div className='rbc-number-total' style={{ marginTop: 8 }}>
              <strong>Total: ${finalPrice}</strong>
            </div>
          </div>

          {/* Promo: supports % or $ amount (kept) */}
          <div className="rbc-filter">
            <label>Promo</label>
            <select
              className="rbc-select"
              value={discountType}
              onChange={function (e) {
                setDiscountType(e.target.value);
                setDiscountValue('');
              }}
            >
              <option value="">None</option>
              <option value="percent">% Discount</option>
              <option value="amount">$ Discount</option>
            </select>

            {discountType && (
              <input
                className="rbc-input"
                type="number"
                value={discountValue}
                onChange={function (e) {
                  setDiscountValue(e.target.value);
                }}
              />
            )}
          </div>

          <div className="rbc-filter">
            <label>Notes</label>
            <textarea
              className="rbc-input"
              rows={3}
              value={notes}
              onChange={function (e) {
                setNotes(e.target.value);
              }}
            />
          </div>

          {error && <p className="rbc-error">{error}</p>}

          <button
            className="rbc-btn rbc-btn--primary"
            disabled={!isValid()}
            onClick={handleProceed}
          >
            Create
          </button>
        </>
      )}
    </div>
  );
};

export default ReceptionCreateBooking;
